// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"7":"7d6f45","267":"b5c5b0","363":"994535","812":"edff19"}[chunkId] + ".js";
};